var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 6,
    rx: 3,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.207 4H3.648V2.566H3.654L4.545 4H5.016V1.858H4.575V3.295H4.569L3.675 1.858H3.207V4ZM6.87063 3.328C6.90063 2.851 6.64563 2.407 6.11763 2.407C5.64663 2.407 5.32563 2.761 5.32563 3.226C5.32563 3.706 5.62863 4.042 6.11763 4.042C6.46863 4.042 6.72363 3.886 6.84363 3.52H6.46863C6.44163 3.616 6.30363 3.721 6.13263 3.721C5.89563 3.721 5.76363 3.598 5.75163 3.328H6.87063ZM5.75163 3.058C5.75763 2.938 5.83563 2.728 6.10563 2.728C6.31263 2.728 6.40563 2.842 6.44463 3.058H5.75163ZM9.40029 2.449H8.96229L8.67729 3.499H8.67129L8.40729 2.449H7.99329L7.73529 3.502H7.72929L7.44429 2.449H6.99429L7.48629 4H7.92729L8.19129 2.959H8.19729L8.47329 4H8.91129L9.40029 2.449Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewIcon);
export default __webpack_public_path__ + "static/media/newIcon.b16af892eff1b8db5613afede050ecf8.svg";
export { ForwardRef as ReactComponent };